import { useState } from 'react';
import './ImageResize.css';
import SharePage from '../SharePage.js';
 
let ImageResize=()=>{
    let [image, setimage]=useState(null);
    let [filee, setfile] = useState(null);
    let inputhandlechange=(e)=>{
        let file = e.target.files[0];
        if(file || file.type === "image/jpeg"){
            document.querySelector(".inputimgcont").style.display="none";
            document.querySelector(".imageshowdiv").style.display="block";
            setfile(file);
            setimage(URL.createObjectURL(file));
        }
    }
let [customwthheigh, setcustomwthheight]=useState('');
 let customdata = [customwthheigh.widht, customwthheigh.height];
  
 
    let inputhandle=(e)=>{ 
        const value = e.target.value;
        const name = e.target.name;
        setcustomwthheight(values =>({...values, [name] : value}));
    }
let [widhheight, setwidhheight] = useState('');  
    let radiobtnhandle=(e)=>{
        if(e.target.checked){
            if(e.target.value === "1024*768"){  
                setwidhheight([1024, 768]);
            }else if(e.target.value === "800*600"){
                setwidhheight([800,600]);
            }else if(e.target.value === "500*480"){
                setwidhheight([500, 480]);
            }else if(e.target.value === "344*336"){
                setwidhheight([344,336]);
            }else if(e.target.value === "245*235"){
                setwidhheight([245,235]);
            }else if(e.target.value === "160*160"){
                setwidhheight([160,160]);
            }else if(e.target.value === "109*132"){
                setwidhheight([132,109]);
            } 
        }
    }
 let final = [widhheight, customdata];
 
    const [newImae, setNewImage] =useState(null);


// Image resizing by creating canvas ----------------------------------
    let Risizebtnfun= async()=>{
    let SIZE;
        customdata[0] !== undefined ?  SIZE=final[1] : SIZE=final[0];
        const file = filee;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload=(e)=>{
        let imageurl = e.target.result; 
        let image = document.createElement('img');
        image.src = imageurl;      
        image.onload=(ev)=>{
            const canvas = document.createElement('canvas');
            // let ratio = 160 / ev.target.width;
            canvas.width = SIZE[1];
            canvas.height = SIZE[0]; 
            const context = canvas.getContext('2d');
            context.drawImage(image, 0,0, canvas.width, canvas.height);
            let newimageurl = context.canvas.toDataURL('image/jpeg', 1);
            setNewImage(newimageurl);
            document.querySelector(".successmsg").innerHTML = "Your image resized successfully";
            document.querySelector(".imageshowdiv").style.display="none";
            document.querySelector(".successimgcont").style.display = "block";
            
        }
    }
   
    }
    let convertedimagedownlaod=()=>{
        let link = document.createElement("a");
        link.href = newImae;
        link.download = "image.jpg";
        link.click();
        document.querySelector(".sharecont").style.display="block";
        document.querySelector(".successimgcont").style.display="none";
    }

    return(
        <div className='resizermaincont'>
            <p className='imgreszerhead'>Image Resizer</p>
            <div className='inputimgcont'>
                <label className='inpllb' htmlFor='hideinptag'>Select Image+</label>
                <input id='hideinptag' style={{display:"none"}} className='inptag' onChange={inputhandlechange} type='file'/>
            </div> 
            <div className='sharecont' style={{display:"none"}}>
                <p style={{color:"green", fontSize:"25px", textAlign:"center"}}>Download Successfully</p>
                <SharePage path='/Converter/ImageResizer' title='Check out this awesome Image Resizer' description="Resize your Images into any resolution"/>

            </div>
            


            <div style={{display:"none"}} className='imageshowdiv'>
                <div className='conmponentdiv'>
                    <div className='imagecnt'>
                        <img alt='imagee' src={image}/>
                    </div> 
                    <div className='choosesizecont'>
                        <p>Document Large Size(1024 X 768 px) <input value="1024*768" onChange={radiobtnhandle} name='size' type='radio'/></p>
                        <p>Document Small Size(800 X 600 px) <input value="800*600"  onChange={radiobtnhandle} name='size' type='radio'/></p>
                        <p>Web Large Size(500 X 480 px) <input value="500*480"  onChange={radiobtnhandle} type='radio' name='size'/></p>
                        <p>Web Small Size(344 X 336 px) <input value="344*336"  onChange={radiobtnhandle} type='radio' name='size'/></p>
                        <p>E-Mail Large Size(245 X 235 px) <input value="245*235"  onChange={radiobtnhandle} type='radio' name='size'/></p>
                        <p>E-Mail Small Size(160 X 160 px) <input value="160*160"  onChange={radiobtnhandle} type='radio' name='size'/></p>
                        <p>Passport Size(109 X 132.3 px) <input value="109*132"  onChange={radiobtnhandle} type='radio' name='size'/></p>
                        <div style={{width:"100%", border:"none"}}>
                            <p>Custom Widht And Height in px</p>
                            <input name='height' onChange={inputhandle}  style={{textAlign:"center"}} placeholder='Width' type='number'/>
                            <input name='widht' onChange={inputhandle} style={{textAlign:"center"}} placeholder='Height' type='number'/>
                            
                        </div>
                    </div>
                </div>
                 <div className='btncont'>
                    <button onClick={Risizebtnfun} className='resizebtn'>Resize</button>
                </div>
            </div> 


            <div style={{display:"none"}}  className='successimgcont'>
                <p style={{color:"green", backgroundColor:"white", margin:"0", fontSize:"22px"}} className='successmsg'></p>
                <img alt='newimage' src={newImae}/>
                <div>
                    <button onClick={convertedimagedownlaod}>Download Converted Image</button>
                </div>
                
            </div>
           
        </div>
    );
}
export default ImageResize;